webpackJsonp([63],{

/***/ 2332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicHistoryQuiz_vue__ = __webpack_require__(2874);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_546e481b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicHistoryQuiz_vue__ = __webpack_require__(3035);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3021)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-546e481b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicHistoryQuiz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_546e481b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicHistoryQuiz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/clinicHistory/quiz/ClinicHistoryQuiz.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-546e481b", Component.options)
  } else {
    hotAPI.reload("data-v-546e481b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_sessionStorage__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__ = __webpack_require__(1228);




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    goToSection: function goToSection(path) {
      var needsPatientId = !this.$store.getters['session/userIsPatient'] && this.$route.query.patientId;
      var route = { path: '' + __WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__["d" /* BASE_PATH */] + (path !== __WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__["O" /* MENU_PATH */] ? '/' + path : ''), query: {} };
      if (needsPatientId) route.query.patientId = this.$route.query.patientId;
      if (this.$route.query.petId) route.query.petId = this.$route.query.petId;
      this.$router.push(route).catch(function () {});
    }
  },
  data: function data() {
    return {
      historyReadOnly: !!sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_0__constants_sessionStorage__["a" /* READ_ONLY_TOKEN_SESSION_STORAGE_KEY */])
    };
  }
});

/***/ }),

/***/ 2874:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_clinicHistory_quiz_ClinicHistoryQuizBlock__ = __webpack_require__(3023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_clinicHistory_quiz_ClinicHistoryQuizForm__ = __webpack_require__(3027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_buttons_BaseButton__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repositories_ClinicHistoryRepository__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_BaseDialog__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_clinicHistory_mixin__ = __webpack_require__(2418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__ = __webpack_require__(1228);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ClinicHistoryQuizBlock: __WEBPACK_IMPORTED_MODULE_0__components_views_clinicHistory_quiz_ClinicHistoryQuizBlock__["a" /* default */],
        ClinicHistoryQuizForm: __WEBPACK_IMPORTED_MODULE_1__components_views_clinicHistory_quiz_ClinicHistoryQuizForm__["a" /* default */],
        BaseButton: __WEBPACK_IMPORTED_MODULE_2__components_base_buttons_BaseButton__["default"],
        BaseDialog: __WEBPACK_IMPORTED_MODULE_4__components_base_BaseDialog__["default"]
    },
    props: {},
    data: function data() {
        return {
            blockIdSelected: null,
            questionsAndAnswers: [],
            nextBlock: {
                healthVars: __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["r" /* FEEDING_HABITS */],
                feedingHabits: __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["P" /* MOOD_AND_HABITS */],
                moodAndHabits: __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["J" /* HISTORY_AND_DISEASES */],
                historyAndDiseases: __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["N" /* MEDICAL_EVALUATION */]
            },
            healthVars: [],
            feedingHabits: [],
            moodAndHabits: [],
            historyAndDiseases: [],
            medicalEvaluation: [],
            completedQuizs: [],
            showDialogMedicalEvaluation: false,
            HEALTH_VARS_PATH: __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["D" /* HEALTH_VARS_PATH */]
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_clinicHistory_mixin__["a" /* default */]],
    created: function created() {
        var _this2 = this;

        Object(__WEBPACK_IMPORTED_MODULE_3__repositories_ClinicHistoryRepository__["a" /* default */])().getCompletedQuizIds().then(function (response) {
            _this2.completedQuizs = response.data.data.map(function (id) {
                return Object(__WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["_6" /* getQuizNameByType */])(id);
            });
            var startBlock = _this2.completedQuizs.length === 5 || _this2.completedQuizs.length === 0 ? __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["C" /* HEALTH_VARS */] : Object(__WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["_6" /* getQuizNameByType */])(Object(__WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["_5" /* getAllQuizTypesIds */])().filter(function (id) {
                return response.data.data.indexOf(id) < 0;
            })[0]);
            _this2.blockIdSelected = startBlock;
            _this2.loadClinicBlock();
        });
    },

    methods: {
        processElementSelected: function processElementSelected(item, elementSelected) {
            if (!item.multipleAnswers) {
                var defaultValue = [{ answerId: elementSelected.answerId, clinicHistoryValue: elementSelected.clinicHistoryValue, emptyValue: elementSelected.emptyValue }];
                item.answersSelected = item.answersSelected.some(function (answer) {
                    return answer.emptyValue === true;
                }) ? defaultValue : item.answersSelected.some(function (answer) {
                    return answer.answerId === elementSelected.answerId;
                }) ? item.answersSelected.filter(function (answer) {
                    return answer.answerId !== elementSelected.answerId;
                }) : defaultValue;
            } else {
                if (elementSelected.emptyValue) {
                    item.answersSelected = [{ answerId: elementSelected.answerId, clinicHistoryValue: null, emptyValue: elementSelected.emptyValue }];
                } else if (item.answersSelected.some(function (answer) {
                    return answer.answerId === elementSelected.answerId;
                })) {
                    item.answersSelected = item.answersSelected.filter(function (answer) {
                        return answer.answerId !== elementSelected.answerId;
                    });
                } else {
                    item.answersSelected = item.answersSelected.filter(function (answer) {
                        return !answer.emptyValue;
                    });
                    item.answersSelected.push(elementSelected);
                }
            }
        },
        getQuizAnswersColumnsAnchor: function getQuizAnswersColumnsAnchor(answerName) {
            return answerName === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["g" /* BLOOD_TYPE */] ? 1 : answerName === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["Q" /* MOOD_LEVEL */] ? 2 : null;
        },
        saveQuizData: function saveQuizData() {
            var _this3 = this;

            if (this.questionsAndAnswers.some(function (item) {
                return item.answers.length > 0 ? item.answersSelected.length === 0 : !item.answersSelected.some(function (answer) {
                    return answer.emptyValue;
                }) && !item.healthVarValue;
            })) {
                this.$store.dispatch('showInfoAlert', this.$t('mustFillAllData'));
                return;
            } else if (this.blockIdSelected === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["N" /* MEDICAL_EVALUATION */] && this.questionsAndAnswers.some(function (item) {
                return (item.answerVarName === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["H" /* HIGH_BLOOD_PRESSURE */] || item.answerVarName === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["M" /* LOW_BLOOD_PRESSURE */]) && item.healthVarValue;
            }) && this.questionsAndAnswers.some(function (item) {
                return (item.answerVarName === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["H" /* HIGH_BLOOD_PRESSURE */] || item.answerVarName === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["M" /* LOW_BLOOD_PRESSURE */]) && !item.healthVarValue;
            })) {
                this.$store.dispatch('showInfoAlert', this.$t('mustFillQuizPressureData'));
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_3__repositories_ClinicHistoryRepository__["a" /* default */])().saveQuiz(this.processQuizToSave()).then(function (response) {
                if (!response.data.data) {
                    _this3.$store.dispatch('showDangerAlert', _this3.$t('httpRequestDefaultError'));
                    return;
                }
                if (!_this3.completedQuizs.some(function (item) {
                    return item === _this3.blockIdSelected;
                })) {
                    _this3.completedQuizs.push(_this3.blockIdSelected);
                }
                _this3.blocks.find(function (item) {
                    return item.id === _this3.blockIdSelected;
                }).completed = true;
                if (_this3.blockIdSelected === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["J" /* HISTORY_AND_DISEASES */]) {
                    _this3.showDialogMedicalEvaluation = true;
                } else if (_this3.blockIdSelected === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["N" /* MEDICAL_EVALUATION */]) {
                    _this3.quizCompleted();
                } else {
                    _this3.blockIdSelected = _this3.nextBlock[_this3.blockIdSelected];
                    _this3.loadClinicBlock();
                }
            });
        },
        processQuizToSave: function processQuizToSave() {
            var values = [];
            var presureVars = this.questionsAndAnswers.filter(function (item) {
                return item.answerVarName && item.answerVarName.indexOf(__WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["f" /* BLOOD_PRESSURE_QUIZ */]) > -1 && item.healthVarValue;
            });
            if (presureVars.length > 0) {
                this.questionsAndAnswers = this.questionsAndAnswers.filter(function (item) {
                    return item.answerVarName.indexOf(__WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["f" /* BLOOD_PRESSURE_QUIZ */]) === -1;
                });
                var highBloodPresure = presureVars.find(function (item) {
                    return item.answerVarName === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["H" /* HIGH_BLOOD_PRESSURE */];
                }).healthVarValue;
                var lowBloodPresure = presureVars.find(function (item) {
                    return item.answerVarName === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["M" /* LOW_BLOOD_PRESSURE */];
                }).healthVarValue;
                values.push({ answerVarName: __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["e" /* BLOOD_PRESSURE */], answersSelected: null, historyVarValue: highBloodPresure + '/' + lowBloodPresure, questionId: null });
            }
            values = values.concat(this.questionsAndAnswers.map(function (item) {
                return { answerVarName: item.answerVarName, answersSelected: item.answers.length > 0 && item.answersSelected.some(function (answer) {
                        return !answer.emptyValue;
                    }) ? item.answersSelected.filter(function (answer) {
                        return !answer.emptyValue;
                    }) : null, historyVarValue: item.answers.length === 0 ? item.healthVarValue : null, questionId: item.id };
            }));
            return { quizTypeId: __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["T" /* QUIZ_TYPES */][this.blockIdSelected], data: values };
        },
        loadClinicBlock: function loadClinicBlock(scrollIntoAnswers) {
            var _this4 = this;

            if (this[this.blockIdSelected].length > 0) {
                this.questionsAndAnswers = this[this.blockIdSelected];
                setTimeout(function () {
                    window.scrollTo({ top: scrollIntoAnswers ? document.getElementsByClassName('neu-card-questions-and-answers')[0].offsetTop : 0, behavior: 'smooth' });
                }, 100);
            } else {
                Object(__WEBPACK_IMPORTED_MODULE_3__repositories_ClinicHistoryRepository__["a" /* default */])().getQuiz(__WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["T" /* QUIZ_TYPES */][this.blockIdSelected]).then(function (response) {
                    _this4.questionsAndAnswers = response.data.data.map(function (item) {
                        return { id: item.question.value, question: _this4.$i18nHelpers.normalize(item.question.name), answerVarName: item.answerVarName, answers: item.answers, healthVarValue: item.healthVarValue ? item.healthVarValue : undefined, answersSelected: item.answersSelected, multipleAnswers: item.multipleAnswer };
                    });
                    _this4[_this4.blockIdSelected] = _this4.questionsAndAnswers;
                    setTimeout(function () {
                        window.scrollTo({ top: scrollIntoAnswers ? document.getElementsByClassName('neu-card-questions-and-answers')[0].offsetTop : 0, behavior: 'smooth' });
                    }, 100);
                });
            }
        },
        showDontKnowAnswer: function showDontKnowAnswer(item) {
            if (this.currentBlockIsCompleted && item.answers.length === 0 && !item.healthVarValue) {
                return true;
            }
            return item.answerVarName === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["g" /* BLOOD_TYPE */] || item.answerVarName === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["Q" /* MOOD_LEVEL */] || Object(__WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["_10" /* showDontKnowAnswerByQuestionId */])(item.id) ? item.answersSelected.length === 0 || item.answersSelected.length === 1 && item.answersSelected.some(function (answer) {
                return answer.emptyValue === true;
            }) : item.answers.length === 0 && !item.healthVarValue;
        },
        dontKnowAnswerTitle: function dontKnowAnswerTitle(item) {
            return item.answerVarName === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["l" /* CHRONIC_DISEASE_QUIZ */] || item.answerVarName === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["m" /* DISEASES_RELATIONSHIP_QUIZ */] || item.answerVarName === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["Q" /* MOOD_LEVEL */] || item.id === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["c" /* ANALYTICS_HIGH_LEVEL */] ? this.$t('noneOfTheAbove') : undefined;
        },
        isCompleted: function isCompleted(blockId) {
            return this.completedQuizs.some(function (item) {
                return item === blockId;
            });
        },
        quizCompleted: function quizCompleted() {
            this.$router.push({ name: 'clinicHistoryMenu' });
        },
        backAction: function backAction() {
            this.goToSection(__WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["D" /* HEALTH_VARS_PATH */]);
        },
        blockSelected: function blockSelected(blockId) {
            this.blockIdSelected = blockId;
            this.loadClinicBlock(true);
        }
    },
    computed: {
        currentBlockIsCompleted: function currentBlockIsCompleted() {
            var _this5 = this;

            return this.completedQuizs.some(function (item) {
                return item === _this5.blockIdSelected;
            });
        },
        saveQuizBtnText: function saveQuizBtnText() {
            return this.blockIdSelected === __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["N" /* MEDICAL_EVALUATION */] ? this.$t('finish') : this.$t('continue');
        },
        readOnly: function readOnly() {
            return !this.$store.getters['session/userIsPatient'] || this.historyReadOnly;
        },
        blocks: function blocks() {
            var _this = this;
            return [{
                id: __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["C" /* HEALTH_VARS */],
                title: '' + this.$t('healthyVars'),
                action: function action() {
                    _this.blockSelected(__WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["C" /* HEALTH_VARS */]);
                }
            }, {
                id: __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["r" /* FEEDING_HABITS */],
                title: '' + this.$t('feedingHabits'),
                action: function action() {
                    _this.blockSelected(__WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["r" /* FEEDING_HABITS */]);
                }
            }, {
                id: __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["P" /* MOOD_AND_HABITS */],
                title: '' + this.$t('moodAndHabits'),
                action: function action() {
                    _this.blockSelected(__WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["P" /* MOOD_AND_HABITS */]);
                }
            }, {
                id: __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["J" /* HISTORY_AND_DISEASES */],
                title: '' + (this.$uiHelpers.isMobile ? this.$t('historyAndDiseasesReduced') : this.$t('historyAndDiseases')),
                action: function action() {
                    _this.blockSelected(__WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["J" /* HISTORY_AND_DISEASES */]);
                }
            }, {
                id: __WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["N" /* MEDICAL_EVALUATION */],
                title: '' + this.$t('medicalEvaluation'),
                action: function action() {
                    _this.blockSelected(__WEBPACK_IMPORTED_MODULE_6__constants_clinicHistory__["N" /* MEDICAL_EVALUATION */]);
                }
            }];
        }
    }
});

/***/ }),

/***/ 2875:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_colours__ = __webpack_require__(42);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        iconSize: function iconSize() {
            return this.$uiHelpers.isMobile ? '30' : '40';
        },
        completedBlockSelected: function completedBlockSelected() {
            return this.completed && this.id === this.blockIdSelected;
        },
        blockSelected: function blockSelected() {
            return !this.completed && this.id === this.blockIdSelected;
        },
        blockOpacity: function blockOpacity() {
            return this.blockIdSelected && this.id !== this.blockIdSelected;
        },
        titleColor: function titleColor() {
            return this.completed ? __WEBPACK_IMPORTED_MODULE_0__constants_colours__["b" /* BLACK_COLOUR */] : '';
        }
    },
    components: {},
    props: {
        id: String,
        title: {
            type: String,
            required: true
        },
        action: {
            type: Function,
            required: true
        },
        completed: Boolean,
        blockIdSelected: String
    },
    data: function data() {
        return {};
    },
    created: function created() {},

    methods: {}
});

/***/ }),

/***/ 2876:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_forms_BaseInput__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_clinicHistory_quiz_ClinicHistoryQuizAnswer__ = __webpack_require__(3030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_clinicHistory__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_clinicHistory_mixin__ = __webpack_require__(2418);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BaseInput: __WEBPACK_IMPORTED_MODULE_0__components_base_forms_BaseInput__["default"],
        ClinicHistoryQuizAnswer: __WEBPACK_IMPORTED_MODULE_1__components_views_clinicHistory_quiz_ClinicHistoryQuizAnswer__["a" /* default */]
    },
    props: {
        question: {
            type: String,
            required: true
        },
        questionId: String,
        answers: Array,
        answerVarName: String,
        inputType: {
            type: String,
            default: function _default() {
                return 'number';
            }
        },
        healthVarValue: [String, Number],
        answersSelected: [Array],
        quizAnswersColumnsAnchor: Number,
        showDontKnowAnswer: Boolean,
        isCompleted: Boolean,
        dontKnowAnswerTitle: {
            type: String,
            default: function _default() {
                return this.$t('dontKnow');
            }
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_clinicHistory_mixin__["a" /* default */]],
    data: function data() {
        return {
            defaultAnswer: {
                id: this.questionId + '-answer',
                name: this.dontKnowAnswerTitle,
                value: null
            },
            VAR_UNITS: __WEBPACK_IMPORTED_MODULE_2__constants_clinicHistory__["_1" /* VAR_UNITS */]
        };
    },
    created: function created() {
        if (this.isCompleted && (this.answers.length > 0 && this.answersSelected.length === 0 || this.answers.length === 0 && !this.healthVarValue)) {
            this.$emit('elementSelected', { answerId: this.defaultAnswer.id, emptyValue: true });
        }
    },

    methods: {},
    computed: {
        readOnly: function readOnly() {
            return !this.$store.getters['session/userIsPatient'] || this.historyReadOnly;
        }
    }
});

/***/ }),

/***/ 2877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_forms_BaseInput__ = __webpack_require__(214);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BaseInput: __WEBPACK_IMPORTED_MODULE_0__components_base_forms_BaseInput__["default"]
    },
    props: {
        id: {
            type: String,
            required: true
        },
        answer: {
            type: String,
            required: true
        },
        answersSelected: Array,
        quizAnswersColumnsAnchor: Number,
        readOnly: Boolean
    },
    data: function data() {
        return {};
    },
    created: function created() {},

    methods: {},
    computed: {
        itemSelected: function itemSelected() {
            var _this = this;

            return this.answersSelected.some(function (item) {
                return item.answerId === _this.id;
            });
        }
    }
});

/***/ }),

/***/ 3021:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3022);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("de3079be", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-546e481b\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClinicHistoryQuiz.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-546e481b\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClinicHistoryQuiz.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3022:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-546e481b]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-546e481b],.slide-down-leave-active[data-v-546e481b]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-546e481b],.slide-down-leave-to[data-v-546e481b]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-546e481b],.slide-fade-left-leave-active[data-v-546e481b]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-546e481b],.slide-fade-left-leave-to[data-v-546e481b]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-546e481b]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-546e481b],.fade-leave-to[data-v-546e481b]{opacity:0\n}\n.history-options-block[data-v-546e481b]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.save-quiz-btn[data-v-546e481b]{text-align:center\n}\n.neu-cards-quiz-ctn>div[data-v-546e481b]{cursor:pointer\n}\n@media only screen and (min-width: 992px){\n.neu-cards-quiz-ctn>div[data-v-546e481b]:not(:last-child){margin-right:2rem\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 3023:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicHistoryQuizBlock_vue__ = __webpack_require__(2875);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1ec263c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicHistoryQuizBlock_vue__ = __webpack_require__(3026);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3024)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d1ec263c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicHistoryQuizBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1ec263c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicHistoryQuizBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/clinicHistory/quiz/ClinicHistoryQuizBlock.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d1ec263c", Component.options)
  } else {
    hotAPI.reload("data-v-d1ec263c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3024:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3025);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2b245126", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d1ec263c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClinicHistoryQuizBlock.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d1ec263c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClinicHistoryQuizBlock.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3025:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-d1ec263c]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-d1ec263c],.slide-down-leave-active[data-v-d1ec263c]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-d1ec263c],.slide-down-leave-to[data-v-d1ec263c]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-d1ec263c],.slide-fade-left-leave-active[data-v-d1ec263c]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-d1ec263c],.slide-fade-left-leave-to[data-v-d1ec263c]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-d1ec263c]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-d1ec263c],.fade-leave-to[data-v-d1ec263c]{opacity:0\n}\n.neu-card[data-v-d1ec263c]{overflow:hidden;-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);padding:3rem 4rem;border-radius:23px;border:1px solid #eee;background-color:#E4E4E4\n}\n@media only screen and (max-width: 575px){\n.neu-card[data-v-d1ec263c]{padding:2rem\n}\n}\n.neu-card-title .btn[data-v-d1ec263c]{margin-top:0px !important\n}\n.neu-card-clinic-history[data-v-d1ec263c]{min-height:155px;background-color:#eee;-webkit-transition:all .5s ease;transition:all .5s ease;text-align:center;margin-top:auto;margin-bottom:auto\n}\n@media only screen and (max-width: 575px){\n.neu-card-clinic-history[data-v-d1ec263c]{min-height:80px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card-clinic-history[data-v-d1ec263c]{min-height:130px\n}\n}\n@media only screen and (min-width: 1024px){\n.neu-card-clinic-history[data-v-d1ec263c]{padding:2rem;margin-bottom:2rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-card-clinic-history[data-v-d1ec263c]{padding:.5rem\n}\n}\n@media only screen and (max-width: 575px){\n.neu-card-clinic-history[data-v-d1ec263c]{padding:1rem;margin-bottom:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card-clinic-history[data-v-d1ec263c]{padding:1rem;margin-bottom:2rem\n}\n}\n.neu-card-clinic-history[data-v-d1ec263c]:hover{border:1px solid #3238C4\n}\n.neu-card-clinic-history p[data-v-d1ec263c]{color:#3238C4;font-weight:bold\n}\n.neu-card-clinic-history div[data-v-d1ec263c]{top:50%;left:50%;margin-right:-50%;transform:translate(-50%, -50%);-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);position:absolute\n}\n@media only screen and (min-width: 1024px){\n.neu-card-clinic-history div[data-v-d1ec263c]{padding:2.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-card-clinic-history div[data-v-d1ec263c]{padding:0.5rem\n}\n}\n.neu-card-clinic-title[data-v-d1ec263c]{vertical-align:middle\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card-clinic-title[data-v-d1ec263c]{max-height:45px;height:auto\n}\n}\n@media only screen and (max-width: 575px){\np[data-v-d1ec263c]{margin-top:0 !important;margin-bottom:0 !important\n}\n}\n.section-completed[data-v-d1ec263c]{background-color:#6AEF89\n}\n.block-selected[data-v-d1ec263c]{background-color:#eee\n}\n.completed-block-selected[data-v-d1ec263c]{border:2px solid #eee !important\n}\n.block-opacity[data-v-d1ec263c]{opacity:0.7\n}\n", ""]);

// exports


/***/ }),

/***/ 3026:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    {
      class: {
        "neu-card": true,
        "neu-card-clinic-history": true,
        "section-completed": _vm.completed,
        "block-selected": _vm.blockSelected,
        "completed-block-selected": _vm.completedBlockSelected
      },
      attrs: { cols: "12", lg: "2" },
      on: {
        click: function($event) {
          return _vm.action()
        }
      }
    },
    [
      _c("div", { staticClass: "my-auto px-2 px-sm-4" }, [
        _c(
          "p",
          {
            staticClass: "neu-card-clinic-title",
            class: {
              "d-inline-block": _vm.$uiHelpers.isMobile,
              gray: _vm.completed
            },
            style: { color: _vm.titleColor }
          },
          [
            _vm._v(_vm._s(_vm.title) + " "),
            _vm.completed
              ? _c(
                  "span",
                  {
                    style:
                      "display: block;font-size: 0.8rem;color: " +
                      _vm.titleColor +
                      ";font-weight: normal;"
                  },
                  [_vm._v("(" + _vm._s(_vm.$t("completedQuiz")) + ")")]
                )
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1ec263c", esExports)
  }
}

/***/ }),

/***/ 3027:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicHistoryQuizForm_vue__ = __webpack_require__(2876);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a87f8502_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicHistoryQuizForm_vue__ = __webpack_require__(3034);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3028)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a87f8502"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicHistoryQuizForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a87f8502_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicHistoryQuizForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/clinicHistory/quiz/ClinicHistoryQuizForm.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a87f8502", Component.options)
  } else {
    hotAPI.reload("data-v-a87f8502", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3028:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3029);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("5b24c072", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a87f8502\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClinicHistoryQuizForm.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a87f8502\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClinicHistoryQuizForm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3029:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-a87f8502]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-a87f8502],.slide-down-leave-active[data-v-a87f8502]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-a87f8502],.slide-down-leave-to[data-v-a87f8502]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-a87f8502],.slide-fade-left-leave-active[data-v-a87f8502]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-a87f8502],.slide-fade-left-leave-to[data-v-a87f8502]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-a87f8502]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-a87f8502],.fade-leave-to[data-v-a87f8502]{opacity:0\n}\n.neu-card-questions-and-answers[data-v-a87f8502]{-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);border:1px solid #eee;border-radius:23px;display:block;background-color:#eee;-webkit-transition:all .5s ease;transition:all .5s ease;text-align:center;margin-top:auto;margin-bottom:auto;padding:2rem;margin-bottom:2rem\n}\n.justify-center[data-v-a87f8502]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.quiz-answer-selected[data-v-a87f8502]{background-color:#6AEF89\n}\n", ""]);

// exports


/***/ }),

/***/ 3030:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicHistoryQuizAnswer_vue__ = __webpack_require__(2877);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3954e6b9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicHistoryQuizAnswer_vue__ = __webpack_require__(3033);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3031)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3954e6b9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicHistoryQuizAnswer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3954e6b9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicHistoryQuizAnswer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/clinicHistory/quiz/ClinicHistoryQuizAnswer.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3954e6b9", Component.options)
  } else {
    hotAPI.reload("data-v-3954e6b9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3031:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3032);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2a83f51a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3954e6b9\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClinicHistoryQuizAnswer.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3954e6b9\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClinicHistoryQuizAnswer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3032:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-3954e6b9]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-3954e6b9],.slide-down-leave-active[data-v-3954e6b9]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-3954e6b9],.slide-down-leave-to[data-v-3954e6b9]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-3954e6b9],.slide-fade-left-leave-active[data-v-3954e6b9]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-3954e6b9],.slide-fade-left-leave-to[data-v-3954e6b9]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-3954e6b9]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-3954e6b9],.fade-leave-to[data-v-3954e6b9]{opacity:0\n}\n.quiz-answer-selected[data-v-3954e6b9]{background-color:#6AEF89 !important;color:white\n}\n.answer-box[data-v-3954e6b9]{border-radius:23px;background-color:white;padding:15px;cursor:pointer;display:inline-block\n}\n", ""]);

// exports


/***/ }),

/***/ 3033:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    {
      staticClass: "my-4",
      attrs: {
        cols: _vm.quizAnswersColumnsAnchor ? 6 : 12,
        lg: _vm.quizAnswersColumnsAnchor ? _vm.quizAnswersColumnsAnchor : 12
      }
    },
    [
      _c(
        "span",
        {
          class: {
            "answer-box": true,
            "quiz-answer-selected": _vm.itemSelected
          },
          attrs: { white: "" },
          on: {
            click: function($event) {
              !_vm.readOnly ? _vm.$emit("elementSelected") : null
            }
          }
        },
        [_vm._v(_vm._s(_vm.answer))]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3954e6b9", esExports)
  }
}

/***/ }),

/***/ 3034:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "neu-card-questions-and-answers", attrs: { cols: "12" } },
    [
      _c(
        "div",
        { staticClass: "my-auto" },
        [
          _c("h3", { domProps: { innerHTML: _vm._s(_vm.question) } }),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-4 justify-center" },
            [
              _vm.answers.length === 0
                ? _c(
                    "b-col",
                    { attrs: { cols: "10", sm: "6", lg: "3" } },
                    [
                      _c("base-input", {
                        staticClass: "form-group",
                        attrs: {
                          disabled: _vm.readOnly,
                          value: _vm.healthVarValue,
                          zeroMarginBottom: "",
                          type: _vm.inputType,
                          min: 0,
                          placeholder: _vm.$t("value")
                        },
                        on: {
                          input: function($event) {
                            return _vm.$emit("inputSelected", $event)
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm.VAR_UNITS[_vm.answerVarName]
                              ? {
                                  key: "append",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        _vm._s(_vm.VAR_UNITS[_vm.answerVarName])
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              : null
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.answers, function(item) {
                return _vm.answers.length
                  ? _c("clinic-history-quiz-answer", {
                      key:
                        _vm.$i18nHelpers.normalize(item.name) +
                        "-" +
                        item.answerId,
                      attrs: {
                        readOnly: _vm.readOnly,
                        quizAnswersColumnsAnchor: _vm.quizAnswersColumnsAnchor,
                        id: item.answerId,
                        answer: _vm.$i18nHelpers.normalize(item.name),
                        answersSelected: _vm.answersSelected
                      },
                      on: {
                        elementSelected: function($event) {
                          return _vm.$emit("elementSelected", {
                            answerId: item.answerId,
                            clinicHistoryValue: item.clinicHistoryValue
                          })
                        }
                      }
                    })
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.showDontKnowAnswer && !_vm.readOnly
                ? _c("clinic-history-quiz-answer", {
                    attrs: {
                      id: _vm.defaultAnswer.id,
                      answer: _vm.defaultAnswer.name,
                      answersSelected: _vm.answersSelected
                    },
                    on: {
                      elementSelected: function($event) {
                        return _vm.$emit("elementSelected", {
                          answerId: _vm.defaultAnswer.id,
                          emptyValue: true
                        })
                      }
                    }
                  })
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a87f8502", esExports)
  }
}

/***/ }),

/***/ 3035:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "b-row",
          { staticClass: "mt-4 neu-cards-quiz-ctn history-options-block" },
          _vm._l(_vm.blocks, function(block) {
            return _c("clinic-history-quiz-block", {
              key: block.id,
              attrs: {
                id: block.id,
                title: block.title,
                action: block.action,
                iconSize: block.iconSize,
                blockIdSelected: _vm.blockIdSelected,
                completed: _vm.isCompleted(block.id)
              }
            })
          }),
          1
        ),
        _vm._v(" "),
        _vm._l(_vm.questionsAndAnswers, function(item) {
          return _c("clinic-history-quiz-form", {
            key: item.id,
            attrs: {
              questionId: item.id,
              question: item.question,
              answers: item.answers,
              answerVarName: item.answerVarName,
              healthVarValue: item.healthVarValue,
              answersSelected: item.answersSelected,
              inputType: item.inputType,
              quizAnswersColumnsAnchor: _vm.getQuizAnswersColumnsAnchor(
                item.answerVarName
              ),
              dontKnowAnswerTitle: _vm.dontKnowAnswerTitle(item),
              showDontKnowAnswer: _vm.showDontKnowAnswer(item),
              isCompleted: _vm.currentBlockIsCompleted
            },
            on: {
              elementSelected: function($event) {
                return _vm.processElementSelected(item, $event)
              },
              inputSelected: function($event) {
                item.healthVarValue = $event
                item.answersSelected = []
              }
            }
          })
        }),
        _vm._v(" "),
        _vm.blockIdSelected
          ? _c(
              "div",
              { staticClass: "save-quiz-btn my-4" },
              [
                !_vm.readOnly
                  ? _c("base-button", { on: { click: _vm.saveQuizData } }, [
                      _vm._v(_vm._s(_vm.saveQuizBtnText))
                    ])
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("base-dialog", {
          attrs: {
            content: _vm.$t("quizDialog.completeMedicalEvaluation"),
            okBtnText: _vm.$t("yes"),
            cancelBtnText: _vm.$t("no"),
            okFn: function() {
              _vm.showDialogMedicalEvaluation = false
              _vm.blockIdSelected = _vm.nextBlock[_vm.blockIdSelected]
              _vm.loadClinicBlock(true)
            },
            cancelFn: function() {
              _vm.showDialogMedicalEvaluation = false
              _vm.quizCompleted()
            }
          },
          model: {
            value: _vm.showDialogMedicalEvaluation,
            callback: function($$v) {
              _vm.showDialogMedicalEvaluation = $$v
            },
            expression: "showDialogMedicalEvaluation"
          }
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-546e481b", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/63.8eebf272e13effb3cd29.js